// extracted by mini-css-extract-plugin
export default {"textInput":"textInput_textInput__Yltiw","my-position":"textInput_my-position__vEDC3","option":"textInput_option__qfkzr","option--important":"textInput_option--important__EVhSc"};